import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.handleClick = this.handleClick.bind(this)
    this.element.addEventListener('click', this.handleClick)
    console.debug('[assign-click] connected for', this.element)
  }

  disconnect() {
    this.element.removeEventListener('click', this.handleClick)
  }

  async handleClick(e) {
    console.debug('[assign-click] click detected', e)
    // Allow normal behavior if Turbo handled it
    if (window.Turbo && e.defaultPrevented) {
      console.debug('[assign-click] defaultPrevented, Turbo handled it')
      return
    }
    e.preventDefault()
    const url = this.urlValue || this.element.getAttribute('href')
    console.debug('[assign-click] fetching url', url)
    if (!url) return

    try {
      const res = await fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      if (!res.ok) {
        console.warn('[assign-click] fetch not ok', res.status)
        return
      }
      const html = await res.text()
      const modalFrame = document.getElementById('modal')
      if (modalFrame) {
        modalFrame.innerHTML = html
        console.debug('[assign-click] injected modal HTML')
        // Dispatch an event so other parts of the app can react (and Turbo listeners)
        try {
          window.dispatchEvent(new CustomEvent('turbo:frame-load', { detail: { frameId: 'modal' } }))
          console.debug('[assign-click] dispatched turbo:frame-load')
        } catch (err) {
          console.warn('[assign-click] dispatch frame-load failed', err)
        }
      } else {
        console.warn('[assign-click] no #modal frame found')
      }
    } catch (err) {
      console.error('[assign-click] Failed to load modal', err)
    }
  }
}
